import styled from 'styled-components';
import { colors } from '../../constants';

export const RangeSlider = styled.input.attrs({
    type: 'range',
})`
    appearance: none;
    width: 100%;
    background: transparent;

    :focus {
        outline: none;
    }

    ::-webkit-slider-thumb {
        -webkit-appearance: none;
        border: none;
        width: 50px;
        height: 50px;
        border: 2px solid ${colors.greenPrimary};
        background-color: ${colors.greenPrimary};
        border-radius: 50%;
        outline: none;
        margin-top: -25px;

        /* :hover {
            border: 2px solid ${colors.white};
        } */
    }

    ::-moz-range-thumb {
        border: none;
        width: 50px;
        height: 50px;
        border: 2px solid ${colors.greenPrimary};
        background-color: ${colors.greenPrimary};
        border-radius: 50%;
        outline: none;
        margin-top: -25px;

        /* :hover {
            border: 2px solid ${colors.white};
        } */
    }

    ::-ms-thumb {
        border: none;
        width: 50px;
        height: 50px;
        border: 2px solid ${colors.greenPrimary};
        background-color: ${colors.greenPrimary};
        border-radius: 50%;
        outline: none;
        margin-top: 0px;

        /* :hover {
            border: 2px solid ${colors.white};
        } */
    }

    ::-webkit-slider-runnable-track {
        width: 100%;
        height: 0px;
        cursor: pointer;
        border: 1px dashed ${colors.greenDark};
    }

    ::-moz-range-track {
        width: 100%;
        height: 0px;
        cursor: pointer;
        border: 1px dashed ${colors.greenDark};
    }

    ::-ms-track {
        width: 100%;
        height: 0;
        border: 1px dashed ${colors.greenDark};
        margin: 25px 0;
    }
`;
